import React from 'react';
import { Container } from 'react-bootstrap';
import "./auth.scss";
import { appName } from '../constants/config';

type Props = {
 children?: React.ReactNode;
};

const AuthLayout = ({ children }: Props) => {
 return (
  <div className="auth-container">
   <Container>
    <h1 className="text-center mb-5">{appName}</h1>    
    {children}
   </Container>
  </div>
 );
};
export default AuthLayout;